import { PromptRefinementResponse, promptRefinement } from '@api';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

interface RefinePromptParams {
  question: string;
  signal?: AbortSignal;
}

export const refinePrompt = ({ question, signal }: RefinePromptParams) => {
  const { path, schema } = promptRefinement.refinePrompt;

  return wretchRequest<PromptRefinementResponse>(path, {
    method: 'post',
    body: { question },
    schema,
    options: { signal },
  });
};
